// 数据说明
/* {
  url: 路径,
  redirect: 重定向,
  name: 名称,
  icon: 图标,
  componentURL: 组件路径 leaf节点使用
  level: 节点级别(无根路径)，parent-一级节点，subNode-非一级树节点, leaf-叶子节点
} */
export const routerData = [
  {
    path: '/dashboard',
    redirect: '/dashboard/analysis',
    level: 'parent',
    name: 'dashboard',
    icon: 'android-wifi',
    children: [
      {path: 'analysis', componentURL: '/dashboard/analysis', name: '分析页', level: 'leaf',},
      {path: 'monitor', componentURL: '/dashboard/monitor', name: '监控页 ', level: 'leaf'},
      {path: 'workplace', componentURL: '/dashboard/workplace', name: '工作台', level: 'leaf'},
    ]
  },
  {
    path: '/form',
    redirect: '/form/basic-form',
    level: 'parent',
    icon: 'activity',
    name: '表单页',
    children: [
      {path: 'basic-form', componentURL: '/form/basicForm', name: '基础表单 '},
      {path: 'step-form', componentURL: '/form/stepForm', name: '分步表单 '},
      {path: 'advanced-form', componentURL: '/form/advancedForm', name: '高级表单 '},
    ]
  },
  {
    path: '/list',
    redirect: '/list/table-list',
    level: 'parent',
    icon: 'createtask',
    name: '列表页',
    children: [
      {path: 'table-list', componentURL: '/list/tablelist', name: '查询表格 '},
      {path: 'basic-list', componentURL: '/list/basiclist', name: '标准列表 '},
      {path: 'card-list', componentURL: '/list/cardlist', name: '卡片列表 '},
      {path: 'search', level: 'subNode', name: '搜索列表 ',children: [
        {path: 'articles', componentURL: '/list/articles', name: '搜索列表(文章)'},
        {path: 'projects', componentURL: '/list/projects', name: '搜索列表(项目)'},
        {path: 'application', componentURL: '/list/application', name: '搜索列表(应用)'},
      ]}
    ]
  },
  {
    path: '/profile',
    redirect: '/profile/basic',
    level: 'parent',
    name: '详情页',
    icon: 'compose',
    children: [
      {path: 'basic', componentURL: '/profile/basic', name: '基础详情页'},
      // {path: 'advanced', component: Advanced, name: '高级详情页 '}
    ]
  },
  {
    path: '/demo',
    redirect: '/demo/bigDataSelect',
    level: 'parent',
    name: '典型业务场景',
    icon: 'checkmark-circled',
    children: [
      {path: 'bigDataSelect', componentURL: 'demo/bigDataSelect', name: '下拉控件大数据情况'},
      {path: 'bigDataTable', componentURL: 'demo/bigDataTable', name: '表格没有分页且数据情况'},
      {path: 'tableSearch', componentURL: 'demo/tableSearch', name: '表格查询'},
      {path: 'tableSelect', componentURL: 'demo/tableSelect', name: '表头选择'}
    ]
  },
  {
    path: '/result',
    redirect: '/result/success',
    level: 'parent',
    name: '结果页',
    icon: 'checkmark-circled',
    children: [
      {path: 'success', componentURL: 'result/success', name: '成功'},
      {path: 'fail', componentURL: 'result/fail', name: '失败'}
    ]
  },
  {
    path: '/exception',
    redirect: '/exception/403',
    level: 'parent',
    icon: 'warning',
    name: '异常页',
    children: [
      {path: '403', componentURL: 'error/403', name: '403'},
      {path: '404', componentURL: 'error/404', name: '404'},
      {path: '500', componentURL: 'error/500', name: '500'}
    ]
  },
]


// WEBPACK FOOTER //
// ./src/gtn/mock/data.js